import Breadcrumb from './Breadcrumb';
import BreadcrumbItem from './BreadcrumbItem';

export { BreadcrumbProps } from './Breadcrumb';
export { BreadcrumbItemProps } from './BreadcrumbItem';

Breadcrumb.Item = BreadcrumbItem;
export default Breadcrumb;



// WEBPACK FOOTER //
// ./components/breadcrumb/index.tsx